
interface FooterProps {
  transparent?: boolean;
}

export function Footer({ transparent = false }: FooterProps) {
  return (
    <footer className={`border-t mt-auto transition-colors ${transparent
      ? 'bg-transparent border-gray-700 dark:border-gray-600'
      : 'bg-gradient-to-r from-gray-800 to-gray-900 dark:from-gray-950 dark:to-black border-gray-700 dark:border-gray-800'
      }`}>
      <div className="container mx-auto px-4 py-6">
        <div className="text-center">
          {/* 개발자 정보 */}
          <div className="mb-3">
            <p className={`${transparent ? "text-white dark:text-gray-100" : "text-gray-400 dark:text-gray-300"} text-sm mb-1.5`}>
              개발 담당: <span className="text-white dark:text-gray-50 font-semibold">정지안</span>
            </p>
            <p className={`${transparent ? "text-white dark:text-gray-100" : "text-gray-400 dark:text-gray-300"} text-sm`}>
              문의:
              <a
                href="mailto:jajeong@wizbase.co.kr"
                className={`${transparent ? "text-white dark:text-gray-100" : "text-gray-400 dark:text-gray-300"} hover:text-white dark:hover:text-gray-50 ml-1 font-medium transition-colors duration-200 underline`}
              >
                jajeong@wizbase.co.kr
              </a>
            </p>
          </div>

          {/* 구분선 */}
          <div className={`border-t my-3 ${transparent ? 'border-gray-600 dark:border-gray-500' : 'border-gray-700 dark:border-gray-800'}`}></div>

          {/* 버전 및 저작권 정보 */}
          <div>
            <p className={`${transparent ? "text-gray-200 dark:text-gray-300" : "text-gray-400 dark:text-gray-400"} text-xs`}>
              © 2026 Wizbase. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
